import { useContext, useEffect, useState } from "react";
import { RootContext } from "../../../../stores";
import { ILogoutRequiredFormValues } from "../../../authentication/_interfaces/ILogoutRequiredFormValues";
import { IOrganizationSignUpFlowValues } from "../_interfaces/IOrganizationSignUpFlowValues";
import { OrganizationProfileLimitStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

export function useOrganizationProfileLimitController(
    values: OrganizationProfileLimitStepValues,
    allValues: IOrganizationSignUpFlowValues,
    update: (patch: Partial<OrganizationProfileLimitStepValues>) => void,
    onSuccess: (override?: Partial<OrganizationProfileLimitStepValues>) => void
): {
    values: ILogoutRequiredFormValues,
    onChange: (patch: Partial<ILogoutRequiredFormValues>) => void,
    onSubmit: (override?: Partial<OrganizationProfileLimitStepValues>) => void,
    isSubmitting: boolean,
    error: string | undefined,
    fieldErrors: Partial<Record<keyof ILogoutRequiredFormValues, string>>
} {
    const rootStore = useContext(RootContext);
    const userStore = rootStore.userStore;

    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof ILogoutRequiredFormValues, string>>>({});
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    useEffect(() => {
        update({
            currentUserEmail: userStore.user.email,
            currentUserName: userStore.user.name,
            backClicked: false
        })
    }, [])

    const submit = async (override?: Partial<OrganizationProfileLimitStepValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);
        try {
            update({ loading: true });
            const result = await rootStore.userStore.logout();
            const patch = {
                isAuthenticated: userStore.isAuthenticated,
                currentUserEmail: userStore.user.email,
                currentUserName: userStore.user.name,
                hasExistingOrganizationProfile: userStore.user.hasOrganizationProfile,
            };
            update({ loading: false });
            update(patch);
            onSuccess(patch);
        } catch {
            setError("Error logging out");
        } finally {
            update({ loading: false });
            setSubmitting(false);
        }
    };

    return {
        values: {
            ...values,
            prompt: "Please logout to create a new user account.",
            loggedOut: false
        },
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}